const formatBytes = (bytes) => {
  if (bytes) {
    var marker = 1024;
    var decimal = 2;
    var kiloBytes = marker;
    var megaBytes = marker * marker;
    var gigaBytes = marker * marker * marker;
    var teraBytes = marker * marker * marker * marker;

    if (bytes < kiloBytes) return bytes + " Bytes";
    else if (bytes < megaBytes) return (bytes / kiloBytes).toFixed(decimal) + " KB";
    else if (bytes < gigaBytes) return (bytes / megaBytes).toFixed(decimal) + " MB";
    else return (bytes / gigaBytes).toFixed(decimal) + " GB";
  }
  else {
    return '0 bytes'
  }
};

const getAssetIconSmall = (type: any, version?: any) => {
  let svgName = 'DOC2';

  if (type) {
    switch (true) {
      case type === 'folder':
        svgName = 'Folder';
        break;
      case type === 'pdf' || type === 'PDF':
        svgName = 'PDF2';
        break;
      case type === 'excel' || type == 'spreadsheet':
        svgName = 'XLS';
        break;
      case type === 'presentation' || type === 'ppt':
        svgName = 'PPT';
        break;
      case type === 'document':
        svgName = 'DOC2';
        break;
      case type === 'txt':
        svgName = 'TXT';
        break;
      case type === 'zip' || type === 'archive':
        if (version === 'v2') {
          svgName = "Zip";
          break;
        }
        svgName = 'ZIP';
        break;
      case type === "mp4" || type === "video" || type === "multimedia":
        svgName = 'MP4';
        break;
      case type === 'avi':
        svgName = 'AVI';
        break;
      case type === 'audio' || type === 'music':
        svgName = 'MP3';
        break;
      case type === 'html':
        svgName = 'HTML2';
        break;
      case type === 'json':
        svgName = 'JSON';
        break;
      case type === 'xml':
        svgName = 'XML';
        break;
      case type === 'javascript':
        svgName = 'JS';
        break;
      case type === 'exe':
        svgName = 'EXE';
        break;
      case type === 'csv':
        svgName = 'CSV';
        break;
      case type === 'psd':
        svgName = 'PSD';
        break;
      case type === 'rtf':
        svgName = 'RTF';
        break;
      case type === 'ai':
        svgName = 'AI';
        break;
      case type === 'css':
        svgName = 'CSS';
        break;

      case type === 'imageType':
        svgName = 'Image';
        break;
      case type === '3d' || type === 'model':
        svgName = 'Three_D_Model';
        break;
      case type === 'cad':
        svgName = 'CAD';
        break;
      case type === 'ebook':
        svgName = 'EBOOK';
        break;
      case type === 'database' || type === 'db':
        svgName = 'Database';
        break;
      case type === 'data':
        svgName = 'DataV2';
        break;
      case type === 'font':
        svgName = 'Font';
        break;
      case type === 'game':
        svgName = 'Game';
        break;
      case type === 'geo' || type === 'gis':
        svgName = 'Geo';
        break;
      case type === 'email':
        svgName = 'Email';
        break;
      case type === 'vm' || type === 'virtual':
        svgName = 'Virtual';
        break;
      case type === 'code' || 
           type === 'typescript' || 
           type === 'python' || 
           type === 'java' || 
           type === 'cpp' || 
           type === 'go' || 
           type === 'php' || 
           type === 'ruby' || 
           type === 'swift' || 
           type === 'kotlin':
        svgName = 'Code';
        break;
    }

    if (type === 'image/tiff') {
      if (version === 'v2') {
        svgName = "Document"
      }
      svgName = 'DocumentMedium';
    };
    return svgName;
  };
};

const getAssetIcon = (type: any, version?: any) => {
  // let svgName = 'Document';
  let svgName = 'DOC2'
  if (type) {
    switch (true) {
      case type === 'folder':
        if (version === 'v2') {
          svgName = "Folder"
          break;
        }
        svgName = 'FolderLarge';
        break;
      case type === 'pdf' || type === 'PDF':
        svgName = 'PDF2'
        break;
      case type === 'excel' || type == 'spreadsheet':
        svgName = 'XLS';
        break;
      case type === 'presentation' || type === 'ppt':
        svgName = 'PPT';
        break;
      case type === 'document':
        svgName = 'DOC2';
        break;
      case type === 'txt':
        svgName = 'TXT';
        break;
      case type === 'zip':
        if (version === 'v2') {
          svgName = "Zip"
          break;
        }
        svgName = 'ZIP';
        break;
      case type === "mp4" || type === "video" || type === "multimedia":
        svgName = 'MP4';
        break;
      case type === 'avi':
        svgName = 'AVI'
        break;
      case type === 'audio' || type === 'music':
        svgName = 'MP3';
        break;
      case type === 'html':
        svgName = 'HTML2';
        break;
      case type === 'archive':
        if (version === 'v2') {
          svgName = "Zip"
          break;
        }
        svgName = 'ZIP';
        break;
      case type === 'json':
        svgName = 'JSON'
        break;
      case type === 'xml':
        svgName = 'XML'
        break;
      case type === 'javascript':
        svgName = 'JS'
        break
      case type === 'exe':
        svgName = 'EXE'
        break
      case type === 'csv':
        svgName = 'CSV'
        break
      case type === 'psd':
        svgName = 'PSD'
        break
      case type === 'rtf':
        svgName = 'RTF'
        break
      case type === 'ai':
        svgName = 'AI'
        break
      case type === 'css':
        svgName = 'CSS'
        break

      case type === 'imageType':
        svgName = 'Image';
        break;
      case type === '3d' || type === 'model':
        svgName = 'Three_D_Model';
        break;
      case type === 'cad':
        svgName = 'CAD';
        break;
      case type === 'ebook':
        svgName = 'EBOOK';
        break;
      case type === 'database' || type === 'db':
        svgName = 'Database';
        break;
      case type === 'data':
        svgName = 'DataV2';
        break;
      case type === 'font':
        svgName = 'Font';
        break;
      case type === 'game':
        svgName = 'Game';
        break;
      case type === 'geo' || type === 'gis':
        svgName = 'Geo';
        break;
      case type === 'email':
        svgName = 'Email';
        break;
      case type === 'vm' || type === 'virtual':
        svgName = 'Virtual';
        break;
      case type === 'code' || 
           type === 'typescript' || 
           type === 'python' || 
           type === 'java' || 
           type === 'cpp' || 
           type === 'go' || 
           type === 'php' || 
           type === 'ruby' || 
           type === 'swift' || 
           type === 'kotlin':
        svgName = 'Code';
        break;
    };
    if (type === 'image/tiff') {
      svgName = 'Document';
    };
    return svgName;
  };
};

const classCreator = (height, width, type) => {
  if (height && width && type === 'image') {
    if (height < 178 && width < 178) {
      return 'AssetCard__asset--image__image-small'
    }
    if (height < 178 && width >= 178) {
      return 'AssetCard__asset--image__image-small'
    }
    if (height >= 178 && width < 178) {
      return 'AssetCard__asset--image__image-small'
    }
  }
  return '';
}
const createNodeMock = (element) => {
  if (element.type === 'div') {
    // This is your fake DOM node for <p>.
    // Feel free to add any stub methods, e.g. focus() or any
    // other methods necessary to prevent crashes in your components.
    return {};
  }
  // You can return any object from this method for any type of DOM component.
  // React will use it as a ref instead of a DOM node when snapshot testing.
  return null;
}



export const setCaretPos = (input_node, pos) => {
  if (input_node.setSelectionRange) {
    input_node.setSelectionRange(pos, pos)
  } else if (input_node.createTextRange) {
    input_node.createTextRange().move('character', pos)
  }
  input_node.focus()
}

export const setAttributeCollectionOfElement = (eleNodes, key, value) => {
  if (eleNodes.length) {
    let i = 0
    while (i < eleNodes.length) {
      eleNodes[i].setAttribute(key, value)
      i++
    }
  }
}

export const elementMatchesSelector = (eleNode, key) => {
  if (!eleNode || !key) return false
  return eleNode.matches(key)
}


const reorder = <T>(list: T[], startIndex: number, endIndex: number) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)
  return result
}

function encode(val: string): string {
  return val
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']')
}

function encodeAxiosParam(value: any): string {
  let v = value
  if (value === null) {
    v = ''
    return encodeURIComponent(v)
  }
  if (toString.call(value) === '[object Date]') {
    v = value.toISOString()
  } else if (typeof value === 'object') {
    v = JSON.stringify(value)
  }
  return encodeURIComponent(v)
}

function paramsSerializer(params: any): string {
  const queryString = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && (Array.isArray(value) ? value.length > 0 : true))
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value.map((v) => `${key}[]=${encodeAxiosParam(v)}`).join('&')
      }
      return `${key}=${encodeAxiosParam(value)}`
    })
    .join('&')
  return encode(queryString)
}
export class Heap<T> {
  private heap: T[];
  private comparator: (a: T, b: T) => number;

  constructor(comparator: (a: T, b: T) => number) {
    this.heap = [];
    this.comparator = comparator;
  }

  // Insert an element into the heap
  push(value: T): void {
    this.heap.push(value);
    this.heapifyUp(this.heap.length - 1);
  }

  // Extract the maximum element from the heap
  pop(): T | undefined {
    if (this.heap.length === 0) return undefined;

    const max = this.heap[0];
    const end = this.heap.pop();

    if (this.heap.length > 0 && end !== undefined) {
      this.heap[0] = end;
      this.heapifyDown(0);
    }

    return max;
  }

  // Get the current heap as an array
  getHeap(): T[] {
    return [...this.heap];
  }


  // check if the heap is empty
  isEmpty(): boolean {
    return this.heap.length === 0;
  }

  // Helper to maintain heap property after insertion
  private heapifyUp(index: number): void {
    const parentIndex = Math.floor((index - 1) / 2);
    if (index > 0 && this.comparator(this.heap[index], this.heap[parentIndex]) > 0) {
      [this.heap[index], this.heap[parentIndex]] = [this.heap[parentIndex], this.heap[index]];
      this.heapifyUp(parentIndex);
    }
  }

  // Helper to maintain heap property after extraction
  private heapifyDown(index: number): void {
    const length = this.heap.length;
    const leftChild = 2 * index + 1;
    const rightChild = 2 * index + 2;
    let largest = index;

    if (leftChild < length && this.comparator(this.heap[leftChild], this.heap[largest]) > 0) {
      largest = leftChild;
    }

    if (rightChild < length && this.comparator(this.heap[rightChild], this.heap[largest]) > 0) {
      largest = rightChild;
    }

    if (largest !== index) {
      [this.heap[index], this.heap[largest]] = [this.heap[largest], this.heap[index]];
      this.heapifyDown(largest);
    }
  }
}

export { formatBytes, getAssetIcon, getAssetIconSmall, classCreator, createNodeMock, reorder, paramsSerializer }
export * from './hooks'